// Shared by betTableBtable (Bollywood) and betTableA2 (AAA).

export const isSusp = (item, key = "b") =>
  !item || String(item.gstatus || "").toUpperCase() !== "OPEN" || !(parseFloat(item[key]) > 0);

// 100 → 100, 25000 → 25K, 100000 → 1L (betTableMogambo formatMinMax)
export const formatMinMax = (num) => {
  if (num == null || num === "") return "0";
  const n = Number(num);
  if (isNaN(n)) return String(num);
  if (n >= 100000) return `${n / 100000}L`;
  if (n >= 1000) return `${n / 1000}K`;
  return String(n);
};
